var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33329 0.666672H5.66663C5.29996 0.666672 4.99996 0.966672 4.99996 1.33334C4.99996 1.70001 5.29996 2.00001 5.66663 2.00001H8.33329C8.69996 2.00001 8.99996 1.70001 8.99996 1.33334C8.99996 0.966672 8.69996 0.666672 8.33329 0.666672ZM6.99996 9.33334C7.36663 9.33334 7.66663 9.03334 7.66663 8.66667V6.00001C7.66663 5.63334 7.36663 5.33334 6.99996 5.33334C6.63329 5.33334 6.33329 5.63334 6.33329 6.00001V8.66667C6.33329 9.03334 6.63329 9.33334 6.99996 9.33334ZM11.6866 4.92667L12.1866 4.42667C12.44 4.17334 12.4466 3.75334 12.1866 3.49334L12.18 3.48667C11.92 3.22667 11.5066 3.23334 11.2466 3.48667L10.7466 3.98667C9.71329 3.16001 8.41329 2.66667 6.99996 2.66667C3.79996 2.66667 1.07996 5.30667 0.99996 8.50667C0.913293 11.8933 3.62663 14.6667 6.99996 14.6667C10.32 14.6667 13 11.98 13 8.66667C13 7.25334 12.5066 5.95334 11.6866 4.92667ZM6.99996 13.3333C4.41996 13.3333 2.33329 11.2467 2.33329 8.66667C2.33329 6.08667 4.41996 4.00001 6.99996 4.00001C9.57996 4.00001 11.6666 6.08667 11.6666 8.66667C11.6666 11.2467 9.57996 13.3333 6.99996 13.3333Z",
    fill: "#28353c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f849fbbc46214eedaea365b2452f4f81.svg";
export { ForwardRef as ReactComponent };